import type { FaireProductEntity } from "../../entity_types/product";

export const p_cm4fj3e19r: FaireProductEntity = {
  token: "p_cm4fj3e19r",
  type: "product",
  name: "2lb Bag of Rainbow Popcorn",
  brandName: "Amish Country Popcorn",
  imageUrl:
    "https://cdn.faire.com/fastly/cebf01dd8ea1392ec0ebb8df79322338eb28bf07f26d06e2c5458cd7b7a10cea.jpeg",
  priceDollars: 1.96,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2225c92800fb623ae6495c4c076d66b224181c45cb0704cea6a6ce778a75634d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
